import watch from "redux-watch";
import isEqual from 'is-equal';
import { deepmerge } from 'utilities/merge';
import { BaseTag } from 'mixs/base/base_mixin';
export class InputTag extends BaseTag {
  init(){
    super.init()
    if(this.opts.value == null && this.opts.riotValue){
      this.opts.value = this.opts.riotValue;
    }
  }
  protected dispatchNewValue(newVal: any) {
    App.store.dispatch(App.actions.data.update(newVal));
  }
}
